import { render, staticRenderFns } from "./addClueContent.vue?vue&type=template&id=635a3610&scoped=true"
import script from "./addClueContent.vue?vue&type=script&lang=js"
export * from "./addClueContent.vue?vue&type=script&lang=js"
import style0 from "./addClueContent.vue?vue&type=style&index=0&id=635a3610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a3610",
  null
  
)

export default component.exports